var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"listFooter row justify-between items-center q-px-md"},[_c('div',[_c('span',{staticClass:"q-mr-sm"},[_vm._v("Powered by")]),_c('a',{attrs:{"href":"javascript: void(0);","target":"_blank"}},[_c('q-img',{attrs:{"basic":"","width":"60px","src":require("assets/images/home/logo.svg")}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }